import { profile as profileApi } from '@afosto/iam/api/Profile';

export default async (path, data) => profileApi.updateProfile(path, data);
